import React from 'react';
import PropTypes from 'prop-types';
import { SpriteSvg } from 'project/sprite-svg';

const ToggleSwitch = ({
    leftLabel, rightLabel, selected, onToggle
}) => {
    const isRight = selected === 'right';

    return (
        <div className="circle-toggle">
            <span className={`circle-toggle__label ${!isRight ? 'active' : ''}`}>
                {leftLabel}
            </span>
            <button
                className={`circle-toggle__switch ${isRight ? 'right' : 'left'}`}
                onClick={onToggle}
                aria-label="Toggle switch"
                type="button"
            >
                <span className="circle-toggle__circle" />
                <SpriteSvg className={`circle-toggle__icon ${isRight ? '' : 'active'}`} iconName="video" width="16" height="16" />
                <SpriteSvg className={`circle-toggle__icon ${isRight ? 'active' : ''}`} iconName="article" width="16" height="16" />
            </button>
            <span className={`circle-toggle__label ${isRight ? 'active' : ''}`}>
                {rightLabel}
            </span>
        </div>
    );
};

ToggleSwitch.propTypes = {
    leftLabel: PropTypes.string.isRequired,
    rightLabel: PropTypes.string.isRequired,
    selected: PropTypes.oneOf(['left', 'right']).isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default ToggleSwitch;
